<template>
  <div>
    <div class="row" v-if="menuprincipal">
      <div class="col-6 mt-3" v-bind:key="currentMenu.name" v-for="currentMenu in modules" v-if="currentMenu.show_in_hh"
        @click="seleccionarMenu(currentMenu)">
        <div class="buttons-group">
          <button class="c-button c-button--lg">
            <div class="icon-w" style="font-size: 2.5em">
              <div :class="currentMenu.icon"></div>
            </div>
            <span style="font-size: 1.3em;" v-html="currentMenu.description"> </span>
          </button>
        </div>
      </div>
    </div>

    <div class="row" v-if="!menuprincipal">
      <div class="ae-side-menu" style="min-width: 100%">
        <div class="aem-head">
          <button @click="regresar" class="btn btn-xs ae-side-menu-toggler" href="#">
            <i class="fa fa-arrow-left"> </i> Regresar
          </button>
        </div>

        <ul class="ae-main-menu" v-for="currentMenu in modules" v-bind:key="'su2b_' + currentMenu.name"
          v-if="sub_menu_name == currentMenu.name && currentMenu.show_in_hh">
          <li v-bind:key="currentSubItem.name" v-for="currentSubItem in currentMenu.items" :to="currentSubItem.to"
            v-if="currentSubItem.show_in_hh">
            <router-link :to="currentSubItem.to">
              <i :class="currentSubItem.icon"> </i>
              <span v-html="currentSubItem.description"> </span>
            </router-link>
          </li>
        </ul>
        <div class="ae-labels">
          <div class="logged-user-w">
            <div class="avatar-w">
              <img alt v-bind:src="user.image" />
            </div>
            <div class="logged-user-info-w">
              <div class="logged-user-name" v-html="user.name"></div>
              <div class="logged-user-role" v-html="user.email"></div>
            </div>
          </div>

          <a class="ae-label ae-label-red" href="#">
            <span class="label-pin"> </span>
            <span class="label-value">Cerrar Sesión</span>
            &nbsp
            <i class="fas fa-power-off"></i>
          </a>
          <!--a class="ae-label ae-label-green" href="#">
            <span class="label-pin"> </span>
            <span class="label-value">Personal</span>
          </a>
          <a class="ae-label ae-label-blue" href="#">
            <span class="label-pin"> </span>
            <span class="label-value">Statements</span>
          </a>
          <a class="ae-label ae-label-yellow" href="#">
            <span class="label-pin"> </span>
            <span class="label-value">Projects</span>
          </a-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      user: {
        name: "",
        image: "",
        email: "",
      },
      menuprincipal: true,
      sub_menu_name: "",
    };
  },
  props: {},
  watch: {},
  computed: {
    module() {
      return this.$store.getters.module;
    },
    modules() {
      return this.$store.getters.modules;
    },
  },
  created() {
    this.user.name = localStorage.getItem("name");
    this.user.email = localStorage.getItem("email");
    this.user.image = "http://localhost:8000" + localStorage.getItem("image");
  },
  mounted() { },
  methods: {
    regresar() {
      let self = this;
      self.sub_menu_name = "";
      self.menuprincipal = true;
    },
    toggleMenu() {
      $(".menu-mobile .menu-and-user").slideToggle(200, "swing");
    },
    seleccionarMenu(currentMenu) {
      let self = this;
      self.sub_menu_name = currentMenu.name;
      self.menuprincipal = false;
    },
  },
};
</script>

<style>
.c-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-family: inherit;
  display: inline-block;
  border: 0;
  border-radius: 0.3125em;
  background: #f2f2f2;
  border: solid 1px #ccc;
  color: rgb(94, 178, 40);
  padding: 0.625em 0.5em;
  font-size: 1rem;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  width: 100%;
  transition: 0.3s ease-out;
}

.c-button:hover {
  background: #fff;
}

.c-button:focus {
  outline: none;
  box-shadow: 0 0 0 4px #000;
}

.c-button svg {
  display: block;
  text-align: center;
  /*fill: #000;*/
  fill: rgb(94, 178, 40);
  width: 100%;
  height: 1.5em;
  margin-right: 0.25em;
}

.c-button--lg {
  font-size: 16px;
}

.buttons-group {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
</style>